import React from "react";
import HomeButton from "../components/HomeButton";

export default () =>
    <div className="content shadow">
        <h3>Innstillinger</h3>
        <p>Under utvikling - kommer senere.</p>
        <HomeButton/>
    </div>;